import { Grid, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import LabelPrinter from "../../../../components/LabelPrinter";
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import { useQuery } from "react-query";
import axiosClient from "../../../../lib/axios";
import { IDataPosicaoAtualFinanceiro } from "../../../../types/api/financeiro/posicao-atual-financeiro";
import LoadingApiQuery from "../../../../components/LoadingApiQuery";
import { formatarValorMonetario } from "../../../../helpers/masks";

export default function CardDadosDashboard() {

    //query
    const { data: resultPosicaoFinanceiro, isLoading: isLoadingPosicaoFinanceiro } = useQuery({
        queryKey: ["posicao-atual-financeiro"],
        queryFn: () => axiosClient.get("financeiro/posicao-atual-financeiro")
    });
    const { dataPosicaoFinanceiro }: IPosicaoFinanceiro = {
        dataPosicaoFinanceiro: resultPosicaoFinanceiro?.data || []
    }
    //

    return (
        <Box component={Paper} style={{ height: '100%' }} p={2}>
            <Typography mb={2} variant='h6'>Dashboard</Typography>
            {
                isLoadingPosicaoFinanceiro &&
                <LoadingApiQuery />
            }

            {
                !isLoadingPosicaoFinanceiro &&
                <Grid container spacing={2}>
                    <Grid size={{xs: 12, md: 6}} display="flex" alignItems="center" gap={2}>
                        <PaidOutlinedIcon color="success" sx={{ fontSize: 42 }} />
                        <Box>
                            <Typography mb={0.5}>Títulos a receber hoje</Typography>
                            <Typography fontWeight="bold" fontSize={28}>{formatarValorMonetario(Number(dataPosicaoFinanceiro.titulos_receber_hoje))}</Typography>
                        </Box>
                    </Grid>

                    <Grid size={{xs: 12, md: 6}} display="flex" alignItems="center" gap={2}>
                        <PaidOutlinedIcon color="error" sx={{ fontSize: 42 }} />
                        <Box>
                            <Typography mb={0.5}>Títulos a pagar hoje</Typography>
                            <Typography fontWeight="bold" fontSize={28}>{formatarValorMonetario(Number(dataPosicaoFinanceiro.titulos_pagar_hoje))}</Typography>
                        </Box>
                    </Grid>

                    <Grid size={{xs: 12, md: 6}} display="flex" alignItems="center" gap={2}>
                        <Box width={42} />
                        <LabelPrinter
                            titulo="Recebidos hoje"
                            valor={formatarValorMonetario(Number(dataPosicaoFinanceiro.titulos_recebidos_hoje))}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}} display="flex" alignItems="center" gap={2}>
                        <Box width={42} />
                        <LabelPrinter
                            titulo="Pagos hoje"
                            valor={formatarValorMonetario(Number(dataPosicaoFinanceiro.titulos_pagos_hoje))}
                        />
                    </Grid>
                </Grid>
            }
        </Box>
    )
}

interface IPosicaoFinanceiro {
    dataPosicaoFinanceiro: IDataPosicaoAtualFinanceiro
}